import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useNotice } from '../../state/NoticeContext.jsx';
import { authApi } from '../../api/endpoints.js';
import { Button, Card, Text } from '../../ui.jsx';

export default function ResetPassword() {
  const notice = useNotice();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', code: '', password: '' });
  const [busy, setBusy] = useState(false);

  const set = (key) => (event) => setForm({ ...form, [key]: event.target.value });

  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    try {
      const data = await authApi.resetPassword({
        email: form.email.trim(),
        code: form.code.trim(),
        password: form.password
      });
      notice.success(data.message);
      navigate('/signin', { replace: true });
    } catch (error) {
      notice.fromError(error);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="authw">
      <Card>
        <h1 style={{ fontSize: 24, marginBottom: 4 }}>Choose a new password</h1>
        <p className="mu" style={{ marginBottom: 16 }}>
          Enter the code we emailed you and pick a new password. Every existing session ends
          immediately.
        </p>
        <form onSubmit={submit}>
          <Text label="Email" type="email" required autoComplete="email" value={form.email} onChange={set('email')} />
          <div style={{ height: 12 }} />
          <Text
            label="Reset code"
            required
            inputMode="numeric"
            autoComplete="one-time-code"
            value={form.code}
            onChange={set('code')}
          />
          <div style={{ height: 12 }} />
          <Text
            label="New password"
            type="password"
            required
            minLength={8}
            autoComplete="new-password"
            hint="At least 8 characters."
            value={form.password}
            onChange={set('password')}
          />
          <div style={{ height: 16 }} />
          <Button type="submit" busy={busy} style={{ width: '100%' }}>Update password</Button>
        </form>
        <p className="mu" style={{ marginTop: 16, textAlign: 'center' }}>
          <Link to="/signin">Back to log in</Link>
        </p>
      </Card>
    </div>
  );
}
